import { CloseOutlined } from "@mui/icons-material";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import React, { useState } from "react";

function FilterAllSuperAdminModel({ open, searchParams, setSearchParams, handleClose, handleClickSearch }) {
    const [searchParam, setSearchParam] = useState(searchParams);
    const handleChange = e => {
        const value = e.target.value;
        const name = e.target.name;
        setSearchParam({ ...searchParam, [name]: value });
    };

    const onClickClear = () => {
        setSearchParams({
            name: "",
            email: "",
            mobileNumber: "",
            status: "",
        });
        handleClickSearch({
            name: "",
            email: "",
            mobileNumber: "",
            status: "",
        });
    };

    return (
        <React.Fragment>
            <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="h5">Super Admin Filter</Typography>
                    <IconButton onClick={() => handleClose()}>
                        <CloseOutlined />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent
                    sx={{
                        overflowY: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        gap: "30px",
                        width: "500px",
                    }}
                >
                    <Grid container fullWidth justifyContent={"space-between"}>
                        <Grid item md={5.5}>
                            <TextField
                                value={searchParam.name}
                                name="name"
                                onChange={handleChange}
                                label="Super Admin Name"
                                fullWidth
                                placeholder="Enter Super Admin Name"
                            />
                        </Grid>
                        <Grid item md={5.5}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-controlled-open-select-label">Status</InputLabel>
                                <Select
                                    labelId="demo-controlled-open-select-label"
                                    id="demo-controlled-open-select"
                                    name="status"
                                    value={searchParam.status}
                                    label="Status"
                                    onChange={handleChange}
                                >
                                    <MenuItem value={"Active"}>Active</MenuItem>
                                    <MenuItem value={"InActive"}>InActive</MenuItem>
                                    <MenuItem value={"password_not_reset"}>Password_not_reset</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container fullWidth justifyContent={"space-between"}>
                        <Grid item md={5.5}>
                            <TextField
                                name="email"
                                value={searchParam.email}
                                onChange={handleChange}
                                label="Email"
                                fullWidth
                                placeholder="Enter Email Id"
                            />
                        </Grid>

                        <Grid item md={5.5}>
                            <TextField
                                name="mobileNumber"
                                value={searchParam.mobileNumber}
                                onChange={handleChange}
                                label="Mobile"
                                fullWidth
                                placeholder="Enter Mobile Number"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions
                    style={{
                        padding: "1rem 1.5rem",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: ".25rem",
                    }}
                >
                    <Button variant="contained" color="error" onClick={() => onClickClear()}>
                        Clear
                    </Button>
                    <Button variant="contained" color="primary" onClick={() => handleClickSearch(searchParam)} autoFocus>
                        Search
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default FilterAllSuperAdminModel;
